import { createContext } from 'react'

import type { UseDrawerProviderReturn } from './use-drawer'

export type DrawerContext = Partial<UseDrawerProviderReturn>

export const DrawerContext = createContext<DrawerContext>({})
